import {
  APP_API_KEY,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  itemCount,
} from "Constants";

import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest,
  postMultipartRequest,
  getCustomRequest,
} from "NetworkCall";
import { updateEvent } from "ActionsMessage";
export var CHECKOUT_MODAL = "CHECKOUT_MODAL";
export var CHECKOUT_DETAILS = "CHECKOUT_DETAILS";
export var GLOBAL_COUNT = "GLOBAL_COUNT";
export var CONTACTUS_MODAL = "CONTACTUS_MODAL";

export function openCheckoutModal(showModal, price) {
  return { type: CHECKOUT_MODAL, payload: showModal };
}

export function openContactUsModal(showModal) {
  return { type: CONTACTUS_MODAL, payload: showModal };
}

export function updateCheckoutDetails(details) {
  return { type: CHECKOUT_DETAILS, payload: details };
}

export function makeStripePayment(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/stripe/charges`;
  //debugger;
  return (dispatch) => {
    var successCallback = (data) => {
      var returnData = { error: 0, data: data };
      callback(returnData);
    };

    var errorCallback = (error) => {
      var returnData = { error: 1, data: error };
      callback(returnData);
    };
    postRequest(url, values, session, dispatch, successCallback, errorCallback);
  };
}

export function makePayment(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/makePayments`;

  var paymentsJson = { ...values };

  return (dispatch) => {
    var successCallback = (data) => {
      //var returnData = {error:0,data:data};

      var event_successCallback = (data) => {
        var returnData = { error: 0, data: data };
        callback(returnData);
      };

      var event_errorCallback = (error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      };
      var request = { published: 1, packageon: values.package };
      dispatch(
        updateEvent(
          session,
          request,
          event_successCallback,
          event_errorCallback
        )
      );
    };

    var errorCallback = (error) => {
      var returnData = { error: 1, data: error };
      callback(returnData);
    };

    postRequest(
      url,
      paymentsJson,
      session,
      dispatch,
      successCallback,
      errorCallback
    );
  };
}

export function updateEmailID(values, session, callback) {}

export function fetchGlobalCount(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/globalCount`;
  var body = {
    eventid: session.eventid,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({ type: GLOBAL_COUNT, payload: response.result });
        callback({ success: 1 });
      },
      (error) => {

        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateAdmin(values, session, callback) {
  //NOT used

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/adminuser`;

  var paymentsJson;

  paymentsJson = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    var successCallback = (data) => {
      var returnData = { error: 0, data: data };
      callback(returnData);
    };

    var errorCallback = (error) => {
      var returnData = { error: 1, data: error };
      callback(returnData);
    };
    postRequest(
      url,
      paymentsJson,
      session,
      dispatch,
      successCallback,
      errorCallback
    );
    var request = { published: 1 };
    dispatch(updateEvent(session, request, successCallback, errorCallback));
  };
}

export function sendMessage(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/sendMessage`;
  var body = {
    email: values.email,
    message: values.message,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {

        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateEventPublish(session, status, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event `;
  var body = { resource: { eventid: id, published: status } };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
